import ShareJd from './ShareJd';

export default ShareJd;
